import React from 'react';
import tablerReloadIcon from "@/images/icons/tabler_reload.svg";
import './WidgetDataReloadButton.scss';

interface WidgetDataReloadButtonProps {
  onReload: () => void;
  text?: string;
}

const WidgetDataReloadButton = ({
  onReload,
  text = "Reload",
}: WidgetDataReloadButtonProps) => {
  return (
    <button
      onClick={onReload}
      className="button-with-icon-outcomes d-flex align-items-center"
    >
      <span className="button-with-icon-outcomes-text">{text}</span>
      <img className="retry-icon mr-2" src={tablerReloadIcon} alt="reload" />
    </button>
  );
};

export default WidgetDataReloadButton;